import { useCallback, useState } from "react"
import { Button, Grid, Input, Slider, Toast } from "antd-mobile"
import { DATA_TYPE, getData, setData } from "../../api/userData"

function AddNewProduct() {
  const [kcal, setKcal] = useState(200)
  const [kcal2, setKcal2] = useState(200)
  const [fat, setFat] = useState(10)
  const [prot, setProt] = useState(10)
  const [carb, setCarb] = useState(10)
  const [productName, setProductName] = useState("")
  const onAddKKal = useCallback(() => {
    const data = { value: getData(DATA_TYPE.DIET)?.value || [] }

    data.value = [
      ...data.value,
      {
        name: `|${kcal}|0|0|0`,
        createdAt: new Date().toLocaleDateString(),
        id: data.value.length,
        weight: 100,
      },
    ]

    setData(DATA_TYPE.DIET, data)
    openNotification()
  }, [kcal])

  const saveToDB = useCallback(() => {
    const data = getData(DATA_TYPE.CUSTOM) || {}
    data[`${productName}|${kcal2}|${fat}|${prot}|${carb}`] = {}
    setData(DATA_TYPE.CUSTOM, data)
  }, [carb, fat, kcal2, productName, prot])

  const onAddToAte = useCallback(() => {
    const data = { value: getData(DATA_TYPE.DIET)?.value || [] }

    data.value = [
      ...data.value,
      {
        name: `${productName}|${kcal2}|${fat}|${prot}|${carb}`,
        createdAt: new Date().toLocaleDateString(),
        id: data.value.length,
        weight: 100,
      },
    ]

    setData(DATA_TYPE.DIET, data)
    saveToDB()
    openNotification()
  }, [carb, fat, kcal2, productName, prot, saveToDB])

  const onAddToDB = useCallback(() => {
    saveToDB()
    openNotification()
  }, [saveToDB])

  const openNotification = () => {
    Toast.show({
      content: "Добавлено",
      position: "bottom",
    })
  }

  const onChangeKcal = useCallback((value) => {
    setKcal(value)
  }, [])

  const onChangeKcal2 = useCallback((value) => {
    setKcal2(value)
  }, [])

  const onChangeFat = useCallback((value) => {
    setFat(value)
  }, [])

  const onChangeProt = useCallback((value) => {
    setProt(value)
  }, [])

  const onChangeCarb = useCallback((value) => {
    setCarb(value)
  }, [])

  const onChangeProductName = useCallback((name) => {
    setProductName(name)
  }, [])

  return (
    <Grid
      columns={12}
      gap={12}
      style={{ marginLeft: 16, marginRight: 16, width: "100%" }}
    >
      <Grid.Item span={12}>
        <p>Съедено калорий:</p>
        <div style={{ display: "flex", paddingBottom: 18 }}>
          <p style={{ margin: "auto" }}>Калорий: {kcal} ккал.</p>
        </div>
        <Slider
          step={10}
          defaultValue={kcal}
          min={0}
          max={900}
          onChange={onChangeKcal}
        />
      </Grid.Item>
      <Grid.Item span={12} style={{ paddingTop: 4 }}>
        <Button
          block
          color="success"
          fill="outline"
          size="large"
          onClick={() => onAddKKal()}
        >
          Добавить калорий
        </Button>
      </Grid.Item>
      <Grid.Item span={12} style={{ marginRight: 8 }}>
        <p>Или добавить новый продукт</p>
        <Input
          style={{
            background: "#86D27B62",
            border: "1px solid #86D27B",
            borderRadius: 4,
            paddingTop: 12,
            paddingBottom: 12,
            paddingLeft: 8,
          }}
          placeholder="Название продукта"
          value={productName}
          onChange={onChangeProductName}
        />
        <p>Все параметры на 100 грамм продукта</p>
        <div style={{ display: "flex", paddingBottom: 18 }}>
          <p style={{ margin: "auto" }}>Калорий: {kcal2} ккал.</p>
        </div>
        <Slider
          step={10}
          defaultValue={kcal2}
          min={0}
          max={900}
          onChange={onChangeKcal2}
        />
        <div style={{ display: "flex", paddingBottom: 18 }}>
          <p style={{ margin: "auto" }}>Жиры: {fat} г.</p>
        </div>
        <Slider
          step={1}
          defaultValue={10}
          min={0}
          max={100}
          onChange={onChangeFat}
        />
        <div style={{ display: "flex", paddingBottom: 18 }}>
          <p style={{ margin: "auto" }}>Белки: {prot} г.</p>
        </div>
        <Slider
          step={1}
          defaultValue={10}
          min={0}
          max={100}
          onChange={onChangeProt}
        />
        <div style={{ display: "flex", paddingBottom: 18 }}>
          <p style={{ margin: "auto" }}>Углеводы: {carb} г.</p>
        </div>
        <Slider
          step={1}
          defaultValue={10}
          min={0}
          max={100}
          onChange={onChangeCarb}
        />
      </Grid.Item>
      <Grid.Item span={12} style={{ paddingTop: 20 }}>
        <Button
          block
          color="success"
          fill="outline"
          size="large"
          onClick={() => onAddToAte()}
        >
          Добавить в съеденное
        </Button>
      </Grid.Item>
      <Grid.Item span={12}>
        <Button
          block
          color="success"
          fill="outline"
          size="large"
          onClick={() => onAddToDB()}
        >
          Только в базу данных
        </Button>
      </Grid.Item>
    </Grid>
  )
}

export default AddNewProduct
